import { axiosRequest } from "../../configs/axios.config";

/**
 * @typedef {Object} TransactionalMovementsReportResponse
 * @property {string} message
 * @property {string} token
 */

/**
 * @typedef {Object} TransactionalMovementsReportBody
 * @property {number[]} selection_process_ids — Ids explícitos (p. ej. fila visible en listado o proceso en Kanban).
 */

/**
 * @param {TransactionalMovementsReportBody} body
 * @returns {Promise<import('axios').AxiosResponse<TransactionalMovementsReportResponse>>}
 */
export function createTransactionalMovementsReport(body) {
  return axiosRequest.post("/reports/transactional_movements", body, {
    headers: { Accept: "application/json" },
  });
}
